import app from "@/main";
const localeDateString = {
  dateTime: "%a %e %b %X %Y",
  date: "%d/%m/%Y",
  time: "%H:%M:%S",
  periods: [app.$gettext("AM"), app.$gettext("PM")],
  days: [
    app.$gettext("Sunday"),
    app.$gettext("Monday"),
    app.$gettext("Tuesday"),
    app.$gettext("Wednesday"),
    app.$gettext("Thursday"),
    app.$gettext("Friday"),
    app.$gettext("Saturday")
  ],
  shortDays: [
    app.$gettext("Sun"),
    app.$gettext("Mon"),
    app.$gettext("Tue"),
    app.$gettext("Wed"),
    app.$gettext("Thu"),
    app.$gettext("Fri"),
    app.$gettext("Sat")
  ],
  months: [
    app.$gettext("January"),
    app.$gettext("February"),
    app.$gettext("March"),
    app.$gettext("April"),
    app.$gettext("May"),
    app.$gettext("June"),
    app.$gettext("July"),
    app.$gettext("August"),
    app.$gettext("September"),
    app.$gettext("October"),
    app.$gettext("November"),
    app.$gettext("December")
  ],
  shortMonths: [
    app.$gettext("Jan"),
    app.$gettext("Feb"),
    app.$gettext("Mar"),
    app.$gettext("Apr"),
    app.$gettext("May"),
    app.$gettext("Jun"),
    app.$gettext("Jul"),
    app.$gettext("Aug"),
    app.$gettext("Sep"),
    app.$gettext("Oct"),
    app.$gettext("Nov"),
    app.$gettext("Dec")
  ]
};

export { localeDateString };
